module.exports = "/images/df79e481d37381251d423fe514787d22.png";